<template>
  <div v-show="band.show">
    <a @click="expanded = !expanded"
       class="panel-block band">
      <span class="panel-icon">
        <font-awesome-icon icon="users"></font-awesome-icon>
      </span>
      {{ band.name }}
    </a>
    <div v-show="expanded || forceExpanded">
      <template v-for="(album,key) in band.contents">
        <album v-show="album.show"
               :key="key"
               :album="album"></album>
      </template>
    </div>
  </div>
</template>

<script>
import Album from '@/components/Album';

export default {
  name: 'Band',
  components: {
    Album
  },
  props: {
    band: {
      type: Object,
      default () {
        return {};
      }
    },
    forceExpanded: false
  },
  data () {
    return {
      expanded: false
    };
  }
};
</script>

<style scoped>
.band {
  padding-left: 36px;
  border-top-width: 0px !important;
}
</style>
